export default "/shellGuide.0cb08df0c14b5d8c8973fc0ca9acb857.svg";